<app-page-content [showSearchBox]="true" (search)="search()" [(searchQuery)]="searchQuery" [showProgress]="progress">
  <span pagetitle>Tildel sendinger</span>

  <div style="display: flex; flex-direction: row" pageheaderactions>
    <app-select-box style="width: 150px; margin: auto 0 auto 0.5em"
                    [value]="currentStatus == null ? 'Alle statuser' : currentStatus | orderStatusName">
      <button mat-menu-item (click)="changeFilteredStatus(null)">Alle statuser</button>
      <button mat-menu-item (click)="changeFilteredStatus('Unassigned')">{{ 'Unassigned' | orderStatusName }}</button>
      <button mat-menu-item (click)="changeFilteredStatus('Offer')">{{ 'Offer' | orderStatusName }}</button>
    </app-select-box>

    @if (carriers.length > 20) {
      <app-carrier-search-input (carrierSelected)="changeFilteredCarrier($event)" style="width: 250px; margin: auto 0 auto 0.5em" [value]="currentCarrier">
      </app-carrier-search-input>
    } @else {
      <app-select-box style="width: 150px; margin: auto 0 auto 0.5em" [value]="currentCarrier == null ? 'Alle bærere' : currentCarrier.Name">
        <button mat-menu-item (click)="changeFilteredCarrier(null)">Alle bærere</button>
        <button mat-menu-item *ngFor="let carrier of carriers" (click)="changeFilteredCarrier(carrier)">{{ carrier.Name }}</button>
      </app-select-box>
    }
  </div>

  <div pagecontent>
    <app-shipment-list [showStatusColumn]="true" [showUpdatedAt]="false" [showCreatedAt]="true" [multipleSelect]="multiple" [showAssignColumn]="!multiple" [disableUnchecked]="selectedShipments.length > 10"
                       [shipments]="shipments" (selectionToggled)="selectionToggled($event)"
                       (assignShipment)="assignShipment([$event])" (unassignShipment)="queryUnassignShipment([$event])"
                       (sortChanged)="sortChanged($event)"></app-shipment-list>
  </div>

  <div style="display: flex" pagefooter>
    <app-button-box style="margin: auto">
      <button mat-raised-button color="primary" *ngIf="selectedShipments.length == 0" (click)="toggleMultipleSelect()">
        {{ multiple ? 'VELG EN' : 'VELG FLERE' }}
      </button>
      <button mat-raised-button color="primary" *ngIf="selectedShipments.length > 0" (click)="clearSelection()">NULLSTILL</button>
      <button mat-raised-button color="primary" *ngIf="selectedShipments.length > 0" (click)="assignSelectedShipments()">
        TILDEL
      </button>
      <button mat-raised-button color="warn" *ngIf="selectedShipments.length > 0" (click)="unassignSelectedShipments()">
        FJERN TILDELING
      </button>
    </app-button-box>

    <span style="flex: 1 1 auto"></span>

    <app-paginator [totalCount]=totalShipmentCount
                   [pageSize]=currentPageSize
                   [enablePageSizeSelector]="true"
                   [pageSizeOptions]="[20, 50, 100, 200]"
                   [pageIndex]=currentPage
                   (page)="changePage($event)">
    </app-paginator>
  </div>
</app-page-content>
